import { render, staticRenderFns } from "./AdminDetails.vue?vue&type=template&id=717a707c&scoped=true&"
import script from "./AdminDetails.vue?vue&type=script&lang=js&"
export * from "./AdminDetails.vue?vue&type=script&lang=js&"
import style0 from "./AdminDetails.vue?vue&type=style&index=0&id=717a707c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717a707c",
  null
  
)

export default component.exports